<template>
  <div class="right_box_main">
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                <el-form-item label="名称:" style="margin:0 10 0 0;">
                  <el-input v-model="searchlist.certificatesName" placeholder="请输入模板名称" style="width:160px"></el-input>
                </el-form-item>
                <el-form-item label="类别:" style="margin:0 30 0 0;">
                  <el-select v-model="searchlist.certificatesType" placeholder="--请选择--" style="width:150px" >
                    <el-option v-for="item in Types" 
                      :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建日期:" style="margin:0 30 0 0;">
                  <el-date-picker v-model="queryTime" value-format="yyyy-MM-dd" 
                    type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审批状态:" style="margin:0 30 0 0;">
                  <el-radio-group v-model="searchlist.approvalStatus">
                    <el-radio label="0">待审批</el-radio>
                    <el-radio label="1">通过</el-radio>
                    <el-radio label="2">不通过</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="three">
              <el-button type="primary" size="mini" @click="showDialogForm('','add')" >新增</el-button>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }" border align="center" >
              <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" @row-click="changeColor" :row-style="selectedHighlight" > -->
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                <el-table-column align="center" prop="certificatesName" label="模板名称"></el-table-column>
                <el-table-column align="center" prop="certificatesType" label="证件类别"></el-table-column>
                <el-table-column align="center" prop="createDate" label="创建日期"></el-table-column>
                <el-table-column align="center" prop="approvalStatus" label="审批状态">
                  <template scope="scope">
                    <span class="tab"
                      :class="{ active_tab2: scope.row.approvalStatus == '1',active_tab1:scope.row.approvalStatus=='0',active_tab:scope.row.approvalStatus=='2'}"
                    >{{ scope.row.approvalStatus=='1'?'通过':(scope.row.approvalStatus == '2'?'不通过':'待审批') }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="status" label="状态" width="100px">
                  <template scope="scope">
                    <el-switch v-permission="{sign:'yzsbl:zjblmb:ztxg'}"  v-model="scope.row.status" active-value="0" inactive-value="1" @change="changeStatus(scope.row)">
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="300" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip  class="item" effect="light" content="编辑" placement="top-start">
                      <button v-if="scope.row.approvalStatus!='1'" class="iconfont icon-bianji3 tabBtn" @click="showDialogForm(scope.row.id,'edit')" ></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="审批" placement="top-start" style="fontWeight:bold" >
                      <button v-if="scope.row.approvalStatus == null" class="iconfont icon-shenhe tabBtn" @click="showDialogForm(scope.row.id,'audit')"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                      <button class="iconfont icon-chakan tabBtn" @click="showDialogForm(scope.row.id,'detail')"></button>
                    </el-tooltip>
                     <el-tooltip v-if="scope.row.status!='0'" class="item" effect="light" content="删除" placement="top-start">
                      <button class="iconfont icon-icon7 tabBtn" @click="showdeletepanduan(scope.row.id)"></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :page-size="pageConfig.pageSize" layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange" :total="pageConfig.total" ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog :title="dialogTitle" :visible.sync="showadd" width="900px" :before-close="clearadddata">
      <el-form ref="addform" :model="addform" label-width="110px" size="mini">
        <el-form-item label="证件类型:" prop="certificatesType">
          <el-select :disabled="editDisable" v-model="addform.certificatesType" placeholder="--请选择--" style="width:50%" >
            <el-option v-for="item in Types" 
              :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件名称：" prop="certificatesName">
          <el-input :disabled="editDisable" v-model="addform.certificatesName" placeholder="请输入模板名称" style="width: 50%;"></el-input>
        </el-form-item>
        <!-- 基本信息 -->
        <el-form-item label="基本选项：" prop="basicOptions">
          <el-checkbox-group :disabled="editDisable" v-model="addform.basicOptions" size="small">
            <el-checkbox label="applyName" border>申请人姓名</el-checkbox>
            <el-checkbox label="applyPhone" border>申请人手机号</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 固定信息 -->
        <el-form-item label="固定选项：" prop="fixedOption">
          <el-checkbox-group :disabled="editDisable" v-model="addform.fixedOption" size="small">
            <el-checkbox label="manName" border>男方姓名</el-checkbox>
            <el-checkbox label="manType" border>男方证件</el-checkbox>
            <el-checkbox label="manTypeNo" border>男方证件号码</el-checkbox>
            <el-checkbox label="manCardImg" border>男方身份证</el-checkbox>
            <br>
            <el-checkbox label="womanName" border>女方姓名</el-checkbox>
            <el-checkbox label="womanType" border>女方证件</el-checkbox>
            <el-checkbox label="womanTypeNo" border>女方证件号码</el-checkbox>
            <el-checkbox label="womanCardImg" border>女方身份证</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 选填信息 -->
        <el-form-item label="附件上传：" prop="enclosure">
          <el-checkbox-group :disabled="editDisable" v-model="addform.enclosure" size="small">
            <el-checkbox label="marital" border>婚育证明</el-checkbox>
            <el-checkbox label="baby" border>出生证明</el-checkbox>
            <el-checkbox label="commitment" border>承诺书</el-checkbox>
            <el-checkbox label="others" border>其它</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-radio-group :disabled="editDisable" v-model="addform.status">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showApprove" label="审批结果: ">
          <el-radio-group :disabled="approveDisable" v-model="addform.approvalStatus">
            <el-radio label="1">同意</el-radio>
            <el-radio label="2">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showApprove" label="审批意见: ">
          <el-input :disabled="approveDisable" type="textarea" style="width:50%" :rows="4" 
          placeholder="请输入内容" v-model="addform.approvalOpinion"></el-input>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button v-if="showSaveBtn" type="primary" size="small" style="margin: 0 30px" @click="saveadddata">保存</el-button>
        <el-button type="info" size="small" @click="clearadddata">取消</el-button>
      </div>
    </el-dialog>
    <!-- 审批、详情查看弹框，以模板平铺样式展开 -->
    <el-dialog :title="dialogTitle" :visible.sync="showaudit" width="900px" :before-close="clearadddata">
      <el-form ref="auditform" :model="auditform" label-width="110px" size="mini">
        <el-form-item label="证件类型:">
          <el-select :disabled="editDisable" v-model="auditform.certificatesType" placeholder="--请选择--" style="width:50%" >
            <el-option v-for="item in Types" 
              :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件名称：">
          <el-input :disabled="editDisable" v-model="auditform.certificatesName" placeholder="请输入模板名称" style="width: 50%;"></el-input>
        </el-form-item>
        <!-- 基本信息 -->
        <div v-if="auditform.basicOptions" class="tempItem" style="margin: 20px 0px;height:96px">
          <div class="leftstyle">
            <div>基本信息</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:30px  0 0 0">
              <div class="rdxxflex1">
                <el-form-item v-if="auditform.basicOptions.indexOf('applyName')!=-1" label="申请人姓名:">
                  <el-input size="mini" disabled placeholder="请输姓名" style="width:250px"></el-input>
                </el-form-item>
              </div>
              <div class="rdxxflex2">
                <el-form-item v-if="auditform.basicOptions.indexOf('applyPhone')!=-1" label="申请人手机号:">
                  <el-input size="mini" disabled placeholder="请输入手机号" style="width:250px"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 男方申请资料 -->
        <div v-if="auditform.fixedOption" class="tempItem" style="margin: 20px 0px;height:150px">
          <div class="leftstyle">
            <div>男方申请资料</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:30px  0 0 0">
              <div class="rdxxflex1">
                <el-form-item v-if="auditform.fixedOption.indexOf('manName')!=-1" label="姓名:">
                  <el-input size="mini" disabled placeholder="请输入姓名" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item v-if="auditform.fixedOption.indexOf('manTypeNo')!=-1" label="证件号码:">
                  <el-input size="mini" disabled placeholder="请输入证件号码" style="width:250px"></el-input>
                </el-form-item>
              </div>
              <div class="rdxxflex2">
                <el-form-item v-if="auditform.fixedOption.indexOf('manType')!=-1" label="证件类型:">
                  <el-select v-model="IDType" disabled placeholder="--请选择--" size="mini" style="width:250px">
                    <el-option v-for="item in IDTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 女方申请资料 -->
        <div v-if="auditform.fixedOption" class="tempItem" style="margin: 20px 0px;height:150px">
          <div class="leftstyle">
            <div>女方申请资料</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:30px  0 0 0">
              <div class="rdxxflex1">
                <el-form-item v-if="auditform.fixedOption.indexOf('womanName')!=-1" label="姓名:">
                  <el-input size="mini" disabled placeholder="请输入姓名" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item v-if="auditform.fixedOption.indexOf('womanTypeNo')!=-1" label="证件号码:">
                  <el-input size="mini" disabled placeholder="请输入证件号码" style="width:250px"></el-input>
                </el-form-item>
              </div>
              <div class="rdxxflex2">
                <el-form-item v-if="auditform.fixedOption.indexOf('womanType')!=-1" label="证件类型:">
                  <el-select v-model="IDType" disabled placeholder="--请选择--" size="mini" style="width:250px">
                    <el-option v-for="item in IDTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 男方身份证 -->
        <div v-if="auditform.fixedOption.indexOf('manCardImg')!=-1" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>男方</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div class="rdxxflex1">
                <div class="imgDiv">
                  <img src="../../../assets/images/oneStopProcessing/2.jpg" alt />
                  <span>上传身份证正面</span>
                </div>
              </div>
              <div class="rdxxflex2">
                <div class="imgDiv">
                  <img src="../../../assets/images/oneStopProcessing/3.jpg" alt />
                  <span>上传身份证反面</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 女方身份证资料 -->
        <div v-if="auditform.fixedOption.indexOf('womanCardImg')!=-1" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>女方</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div class="rdxxflex1">
                <div class="imgDiv">
                  <img src="../../../assets/images/oneStopProcessing/2.jpg" alt />
                  <span>上传身份证正面</span>
                </div>
              </div>
              <div class="rdxxflex2">
                <div class="imgDiv">
                  <img src="../../../assets/images/oneStopProcessing/3.jpg" alt />
                  <span>上传身份证反面</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 材料上传 -->
        <div v-if="auditform.enclosure" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>其它</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div v-for="item in enclosure1" :key="item.index" :class="'rdxxflex'+item.index">
                <div class="imgDiv">
                  <img :src="item.img" alt />
                  <span>上传{{item.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="enclosure2.length>0" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>其它</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div v-for="item in enclosure2" :key="item.index" :class="'rdxxflex'+item.index">
                <div class="imgDiv">
                  <img :src="item.img" alt />
                  <span>上传{{item.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-form-item label="状态：" prop="status">
          <el-radio-group :disabled="editDisable" v-model="auditform.status">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showApprove" label="审批结果: ">
          <el-radio-group :disabled="approveDisable" v-model="auditform.approvalStatus">
            <el-radio label="1">同意</el-radio>
            <el-radio label="2">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showApprove" label="审批意见: ">
          <el-input :disabled="approveDisable" type="textarea" style="width:50%" :rows="4" 
            placeholder="请输入内容" v-model="auditform.approvalOpinion"></el-input>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button v-if="showSaveBtn" type="primary" size="small" style="margin: 0 30px" @click="saveadddata">保存</el-button>
        <el-button type="info" size="small" @click="clearadddata">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "../../../utils/request.js"
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  // components: { ViewMap},
  data() {
    return {
      dialogTitle: '新增',
      flag: 'add',
      showadd: false,
      editDisable: false,
      approveDisable: false,
      showApprove: false,
      showSaveBtn: true,
      addform: {
        basicOptions: [],
        fixedOption: [],
        enclosure: []
      },
      Types: [],
      //模板样式弹框
      showaudit: false,
      auditform: {
        basicOptions: '',
        fixedOption: '',
        enclosure: ''
      },
      enclosure1: [],
      enclosure2: [],
      IDTypes: [],
      IDType: '身份证',
      // 查询
      searchlist:{},
      queryTime: [],
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }
    }
  },
  methods: {
    //条件查询
    searchlistdata (){
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset (){
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange (val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas () {
      let fd = new FormData()
      fd.append("token", token)
      fd.append("pageNo", this.pageConfig.pageNo)
      fd.append("pageSize", this.pageConfig.pageSize)
      if(this.queryTime.length > 0){
        this.searchlist.startTime = this.queryTime[0]
        this.searchlist.overTime = this.queryTime[1]
      }
      let params = JSON.stringify(this.searchlist);
      if (params == "{}") {
        params = '{"status":""}'
      }
      console.log(params)
      fd.append("findCertificatesTemplate", params)
      
      var res = await request({
        url: "/certificatesTemplate/info/listCertificatesTemplate",
        method: "POST",
        data: {
            ...this.pageConfig,
            ...this.searchlist
        }
      })
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list
      }else{
        console.log(res)
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    //改变状态
    async changeStatus(cdata) {
      console.log(cdata)
      let fd = new FormData()
      fd.append("token", token)
      let params = JSON.stringify(cdata);
      if (params != "{}") {
        fd.append("updateCertificatesTemplate", params)
      }
      var res = await request({
        url: "/certificatesTemplate/info/updateCertificatesTemplate",
        method: "POST",
        data: fd
      });
      // console.log(res)
      var msg = '状态'
      msg = msg + (cdata.status=='0'?'启用':'禁用')
      if (res.code == 200) {
        this.$message({
          message: msg + '成功',
          type: "success"
        });
      }else{
        this.$message({
            message: msg + "失败：" + res.message,
            type: "error"
          });
      }
    },
    async showDialogForm(id, flag) {
      this.flag = flag
      if(id != ''){
        if(flag == 'edit'){
          this.editDisable = false
          this.showApprove = false
          this.approveDisable = true
          this.showSaveBtn = true
          this.dialogTitle = '编辑'
          this.showaudit = false
          this.showadd = true
        }else if(flag == 'audit'){
          this.editDisable = true
          this.showApprove = true
          this.approveDisable = false
          this.showSaveBtn = true
          this.dialogTitle = '审批'
          this.showadd = false
          this.showaudit = true
        }else if(flag == 'detail'){
          this.editDisable = true
          this.showApprove = true
          this.approveDisable = true
          this.showSaveBtn = false
          this.dialogTitle = '查看'
          this.showadd = false
          this.showaudit = true
        }
        //获取编辑项的最新数据
        let fd = new FormData()
        fd.append("token", token)
        fd.append("id", id)
        var res = await request({
          url: "/certificatesTemplate/info/getCertificatesTemplate",
          method: "POST",
          data: fd
        })
        console.log(res)
        if (res.code == 200) {
          if(this.flag == 'add' || this.flag == 'edit'){
            this.addform = res.content
            //将字符串转数组
            if(this.addform.basicOptions == null ){
              this.addform.basicOptions = []
            }else{
              this.addform.basicOptions = this.addform.basicOptions.split(',')
            }
            if(this.addform.fixedOption == null ){
              this.addform.fixedOption = []
            }else{
              this.addform.fixedOption = this.addform.fixedOption.split(',')
            }
            if(this.addform.enclosure == null ){
              this.addform.enclosure = []
            }else{
              this.addform.enclosure = this.addform.enclosure.split(',')
            }
          }else{  //模板式展示，无需转换数组
            this.auditform = res.content
            var enclosureMap = {
              marital: {index:1, name:'婚育证明', img:require("../../../assets/images/oneStopProcessing/4.jpg")},
              baby: {index:1, name:'出生证明', img:require("../../../assets/images/oneStopProcessing/4.jpg")},
              commitment: {index:1, name:'承诺书', img:require("../../../assets/images/oneStopProcessing/1.jpg")},
              others: {index:1, name:'其它附件', img:require("../../../assets/images/oneStopProcessing/1.jpg")},
            }
            //对附件上传信息进行拆分
            var enclosureArr = this.auditform.enclosure.split(',')
            var index = 0
            var temp = {}
            this.enclosure1 = []
            this.enclosure2 = []
            enclosureArr.forEach(item => {
              if(item != ''){
                index++
                temp = item=='marital'?enclosureMap.marital:(item=='baby'?enclosureMap.baby:(item=='commitment'?enclosureMap.commitment:enclosureMap.others))
                if(this.enclosure1.length < 2){
                  temp.index = this.enclosure1.length + 1
                  this.enclosure1.push(temp)
                }
                if(index > 2 && this.enclosure2.length < 2){
                  temp.index = this.enclosure2.length + 1
                  this.enclosure2.push(temp)
                }
              }
            });
          }
        }else{
          console.log(res.code + '：' +res.message)
          this.$message({
            message: "数据项加载异常",
            type: "error"
          })
          this.showadd = false
          this.showaudit = false
        }
      }else{
        this.editDisable = false
        this.showApprove = false
        this.approveDisable = true
        this.showSaveBtn = true
        this.showadd=true
        this.showaudit = false
        this.dialogTitle = '新增'
        this.addform = {
          basicOptions: [],
          enclosure: [],
          fixedOption: []
        }
      }
      
    },
    //获取新增所有数据发请求
    async saveadddata() {
      let fd = new FormData()
      fd.append("token", token)
      let tempParam = {}
      if(this.flag == 'edit' || this.flag == 'add'){
        //将数组转换成字符串
        this.addform.basicOptions = this.addform.basicOptions.join(',')
        this.addform.fixedOption = this.addform.fixedOption.join(',')
        this.addform.enclosure = this.addform.enclosure.join(',')
        tempParam = this.addform
      }else{
        tempParam = this.auditform
      }
      let params = JSON.stringify(tempParam);
      if (params == "{}") {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false
      }
      // console.log(params)
      fd.append("insertCertificatesTemplate", params)
      let url = '/certificatesTemplate/info/insertCertificatesTemplate'
      if(this.flag == 'edit'){
        fd.append("updateCertificatesTemplate", params)
        url = '/certificatesTemplate/info/updateCertificatesTemplate'
      }else if(this.flag == 'audit'){
        fd.append("approvalCertificatesTemplate", params)
        url = '/certificatesTemplate/info/approvalCertificatesTemplate'
      }
      var res = await request({
        url: url,
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + '成功',
          type: "success"
        });
        this.showadd = false
        this.showaudit = false
        this.pageConfig.pageNo = 1
        this.getPageDatas()
      }else{
        console.log(res)
        this.$message({
            message: this.dialogTitle + "失败：" + res.message,
            type: "error"
          });
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false
      this.showaudit = false
    },
    //删除操作
   async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
          let fd = new FormData()
          fd.append("token", token)
          fd.append("id", id)
          var res = await request({
            url: "/certificatesTemplate/info/deleteCertificatesTemplate",
            method: "POST",
            data: fd
          });
          if (res.code == 200) {
            this.$message({
              message: '删除成功',
              type: "success"
            });
            this.showadd = false
            this.pageConfig.pageNo = 1
            this.getPageDatas()
          }else{
            console.log(res)
            this.$message({
                message: "删除失败：" + res.message,
                type: "error"
              });
          }
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
  },
  mounted() {
    // 初始化数据
    this.Types = [{label:'民政服务',value:'民政服务'},{label:'其它',value:'其它'}]
    this.IDTypes = [
      {label:'身份证号',value:'身份证号'},
      {label:'军官证号',value:'军官证号'},
      {label:'驾驶证号',value:'驾驶证号'},
      {label:'外国人居留证',value:'外国人居留证'}
    ]
    this.getPageDatas()
  }
};
</script>

<style lang="less" scoped>
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
.tempItem {
  border: #cfd8e1 1px solid;
  box-sizing: border-box;
  width: 100%;
  height: 450px;
  // background-color: red;
  display: flex;
  // justify-content: center;
  align-items: center;
  .leftstyle {
    width: 40px;
    height: 100%;
    background-color: #01aaef;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 20px;
      text-align: center;
      font-size: 18px;
      color: #fff;
    }
  }
}
.rdxxright {
  width: calc(100% - 40px);
  height: 100%;
  background-color: #f8faf9;
  .rdxxflextop {
    width: 100%;
    height: 75%;
    display: flex;
    margin-top: 10px;
    .rdxxflex1 {
      flex: 1.5;
      box-sizing: border-box;
      padding-left: 20px;
      .imgDiv{
        width: 270px;
        height: 166px;
        border: 1px dotted #ccc;
        border-radius: 5px;
        margin-left: 90px;
        img{
          float: left;
          width: 90px;
          margin: 40px 90px 10px;
        }
        span{
          width: 100%;
          text-align: center;
          float: left;
        }
      }
    }
    .rdxxflex2 {
      flex: 1.5;
      box-sizing: border-box;
      padding-left: 40px;
      .imgDiv{
        width: 270px;
        height: 166px;
        border: 1px dotted #ccc;
        border-radius: 5px;
        margin-left: 10px;
        img{
          float: left;
          width: 90px;
          margin: 40px 90px 10px;
        }
        span{
          width: 100%;
          text-align: center;
          float: left;
        }
      }
    }
  }
  .rdxxflexbootm {
    width: 100%;
    height: 25%;
  }
}
</style>